import { collection, getDocs } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../firebase/firebaseConfig";
import Sticky1 from "../resources/sticky1.png";
import Sticky2 from "../resources/sticky2.png";
import Sticky3 from "../resources/sticky3.png";
import Sticky4 from "../resources/sticky4.png";

const PrayerWall = () => {
    const [data, setData] = useState([]);
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "Prayer Wall"));
                const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                const querySnapshot2 = await getDocs(collection(db, "Members"));
                const documents2 = querySnapshot2.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                for (let i = 0; i < documents2.length; i++) {
                    for (let j = 0; j < documents.length; j++) {
                      if (documents[j].Member === documents2[i].id) {
                        documents[j].Name = documents2[i].Name;
                        documents[j].Image = documents2[i].ProfileImage;
                      }
                    }
                }
                  

                console.log(documents)
                setData(documents);
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        };
    
        fetchData();
    }, []);

    const images = [Sticky1, Sticky2, Sticky3, Sticky4];

    const generateRandomImage = () => images[Math.floor(Math.random() * images.length)];

    return (
        <div id="content">
            <div className='row'>
                <h1>Prayer Wall</h1>
                <h2 className='ev-sub-title'>Revival Church Montana</h2>
            </div>
            <div className='row'>
                {data.map(item => {
                    return (<div className="col-sm-3" style={{backgroundImage: `url(${generateRandomImage()})`, backgroundSize: "cover", height: '400px', display: 'flex', flexDirection: 'column',alignItems: 'center',justifyContent: 'center',padding: '5%',textAlign: 'center',overflow: 'hidden', backgroundPosition: 'center'}}>
                        <h5>{item.Topic}</h5>
                        <p>{item.Request}</p>
                        <img src={item.Image} style={{width: "50px", borderRadius: "500px"}}/>
                        <p style={{fontSize: "15px", fontWeight: "500"}}>{item.Name}</p>
                    </div>)
                })}
            </div>
        </div>
    )
}

export default PrayerWall; 